import { v4 as uuid } from 'uuid';
import { SchedulerConstants } from './SchedulerConstants';
export class SchedulerService {
    static $inject = ['MessagingHubService', 'AccountService2', 'FileSaver'];
    constructor(MessagingHubService, AccountService2, FileSaver) {
        this.MessagingHubService = MessagingHubService;
        this.AccountService2 = AccountService2;
        this.FileSaver = FileSaver;
        this.cluster = '';
    }
    async downloadSchedulerReport(listIdentity, messageId, nameSchedule, finallyFunction) {
        let exception = undefined;
        try {
            const data = await this.getReport(listIdentity, messageId);
            const response = await fetch(data.resource);
            const blob = await response.blob();
            const fileName = this.getFileName(nameSchedule);
            await this.FileSaver.saveAs(blob, fileName);
        }
        catch (err) {
            exception = err;
            console.error(err);
        }
        finally {
            if (finallyFunction) {
                finallyFunction(exception);
            }
        }
    }
    getFileName(nameSchedule) {
        return SchedulerConstants.SCHEDULER_REPORT_FILE_NAME_PREFIX + nameSchedule + SchedulerConstants.SCHEDULER_REPORT_FILE_EXTENSION;
    }
    async getReport(listIdentity, messageId) {
        const me = await this.AccountService2.me();
        const command = {
            id: uuid(),
            to: SchedulerConstants.SCHEDULER_POSTMASTER,
            method: 'get',
            uri: SchedulerConstants.SCHEDULER_REPORT_URI
                .replace('{listIdentity}', encodeURIComponent(listIdentity))
                .replace('{messageId}', messageId)
                .replace('{language}', me.culture),
        };
        const reportUrl = await this.MessagingHubService.processCommand(command);
        if (!reportUrl) {
            throw new Error('Command returned empty value for scheduler report url');
        }
        return reportUrl;
    }
}
SchedulerService.$inject = ['MessagingHubService', 'AccountService2', 'FileSaver'];
